import script from "./whDOnceImg4_t4A.vue?vue&type=script&setup=true&lang=js"
export * from "./whDOnceImg4_t4A.vue?vue&type=script&setup=true&lang=js"

import "./whDOnceImg4_t4A.vue?vue&type=style&index=0&id=6c929e9e&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c929e9e"]])

export default __exports__